import { Profile } from '../components/Profile'

/**
 * プロフィールページ
 */
export function ProfilePage() {
  return <Profile />
}
